export const FIRST_ADVERTISEMENT_INDEX = 'red_admin_first_advertisement_index'
export const JOB_REFER_DRAFT = 'red_admin_job_refer_draft'
export const AUTH_TOKEN = 'red_admin_auth_token'
export const LOCAL_STORAGE_BANNER_STATUS = 'red_admin_banner_status'
export const SIDE_NAV_OPEN = 'red_admin_side_nav_open'
export const KEEP_CANDIDATE_FILTER_OPEN = 'red_admin_keep_candidate_filter_open'

export type LocalStorageBannerStatus = {
  [key: number]: string // キーはバナーID、値はバナーの最終表示日
}
